module.exports = __webpack_public_path__ + "assets/img/00128.ef19566c.png";